import React, { useEffect, useRef, useState } from 'react';
import { dictionary } from '../../assets/dictionary';
import './steps-modal.scss';
import { Accordion, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { EmergencyHelper } from '../helpers';
import {
    ACTIONS,
    updateEmergencyFromAllEmergenciesActionCreator as updateEmergencyActionCreator,
} from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import { STORE } from '../redux-configs';
import { MainPageApi } from '../main-page/main-page.api';
import { MapComponent } from '../building-blocks';

const mainPageApi = MainPageApi.getInstance();

const notEligibleValues = ([key]: [string, unknown]): boolean =>
    !['id', 'createdAt', 'updatedAt', 'firstName', 'lastName'].includes(key);

function StepsModal({ show, setShow }) {
    const [notes, setNotes] = useState('');
    const [reasonComment, setReasonComment] = useState('');
    const [reallyFinish, setReallyFinished] = useState(false);
    const [falseAlarm, setFalseAlarm] = useState(false);
    const [stepsChecked, setStepsChecked] = useState([]);
    const listRef = useRef(null);
    const falseAlarmRef = useRef(null);
    const dispatch = useDispatch();
    const { selectedEmergency } = useSelector(STORE);

    useEffect(() => {
        console.log('reasonComment', reasonComment);
    }, [reasonComment]);

    const processFinish = async () => {
        const id = selectedEmergency['id'];
        if (falseAlarmRef?.current?.checked) {
            const status = 'finished';
            const reasonComment = 'Хибний/тестовий виклик';
            await mainPageApi.updateEmergencyStatus(id, status);
            const log = await mainPageApi.pushEmergencyLog(selectedEmergency, 'FINISHED');
            delete log.emergency;
            await mainPageApi.leftEmergencyFinishedReasonComment(
                id,
                reasonComment
            );

            const updatedEmergency = {
                ...selectedEmergency,
                logs: [...(selectedEmergency.logs ?? []), log],
                status,
                finishReason: reasonComment,
                finishedAt: EmergencyHelper.prettifyDate(new Date()),
            };

            dispatch(updateEmergencyActionCreator(updatedEmergency));
            dispatch({
                type: ACTIONS.SET_SELECTED_EMERGENCY,
                payload: updatedEmergency,
            });
            setShow(false);
        } else {
            await startProcessing('Подія опрацьована');
        }
    };

    const handleFinish = async (finishReason?) => {
        const status = 'finished';
        const id = selectedEmergency['id'];

        await mainPageApi.updateEmergencyStatus(
            selectedEmergency['id'],
            status
        );
        await mainPageApi.leftEmergencyFinishedReasonComment(id, finishReason ?? reasonComment);

        const log = await mainPageApi.pushEmergencyLog(selectedEmergency, 'FINISHED');
        delete log.emergency;

        const updatedEmergency = {
            ...selectedEmergency,
            status,
            notes: notes || null,
            finishReason: reasonComment,
            logs: [...(selectedEmergency.logs ?? []), log],
            finishedAt: EmergencyHelper.prettifyDate(new Date()),
        };

        dispatch(updateEmergencyActionCreator(updatedEmergency));
    };

    const startProcessing = async (finishReason?) => {
        if (notes !== '') {
            await mainPageApi.addNotesToEmergency(selectedEmergency['id'], notes);
        }
        await handleFinish(finishReason);
        setShow(false);
    }

    const stopProcessing = () => {
        setReallyFinished(false);
    }

    const onChange = e => {
        const checked = e?.target?.checked;
        if (checked) {
            const steps = [...stepsChecked];
            steps.push(e?.target?.name);
            setStepsChecked(steps);
        } else {
            setStepsChecked(stepsChecked.filter(s => s !== e?.target?.name));
        }
    }

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            fullscreen="lg-down"
            className="steps-modal"
        >
            {reallyFinish && (
                <>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Ви остаточно бажаєте завершити подію?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group
                                className="mb-3"
                                controlId="formFinalReason"
                            >
                                <Form.Label>
                                    Будь ласка, вкажіть причину завершення:
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    onChange={(inp) =>
                                        setReasonComment(inp.target.value)
                                    }
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="outline-secondary"
                            onClick={() => stopProcessing()}
                        >
                            Скасувати
                        </Button>
                        <Button
                            variant="primary"
                            disabled={!reasonComment?.length}
                            onClick={() => startProcessing()}
                        >
                            Завершити подію
                        </Button>
                    </Modal.Footer>
                </>
            )}
            {!reallyFinish && (
                <>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h6 className="steps-modal-header">
                                Ім'я: <b>{selectedEmergency.user?.medicalCard?.firstName}</b>
                            </h6>
                            <h6 className="steps-modal-header">
                                Номер телефону: <b>{selectedEmergency.user?.phone}</b>
                            </h6>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container className="steps-container">
                            <Row>
                                <Col lg={7}>
                                    <input
                                        className="mb-3"
                                        type="checkbox"
                                        ref={falseAlarmRef}
                                        onChange={e => setFalseAlarm(e?.target?.checked)}
                                        name="falseAlarm"
                                    />
                                    <label htmlFor="falseAlarm">
                                        Хибний/тестовий виклик?
                                    </label>
                                    <br />
                                    <ol className="steps-list" type="1" ref={listRef}>
                                        {selectedEmergency.comment && (
                                            <li className="mt-2">
                                                <input
                                                    type="checkbox"
                                                    name="comment"
                                                    onChange={onChange}
                                                />
                                                <label htmlFor="comment">
                                                    Зверніть увагу на коментар від
                                                    потерпілого!
                                                </label>
                                                <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header>
                                                            Коментар
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            {selectedEmergency.comment}
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </li>
                                        )}
                                        {selectedEmergency.user?.medicalCard && (
                                            <li>
                                                <input checked={stepsChecked.includes('medical')} type="checkbox" name="medical" onChange={onChange} />
                                                <label htmlFor="medical">
                                                    Ознайомтесь із медичною книгою!
                                                </label>
                                                <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header>
                                                            Медична книга
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            {Object.entries(
                                                                selectedEmergency.user
                                                                    ?.medicalCard
                                                            )
                                                                .filter(notEligibleValues)
                                                                .map(
                                                                    (entry, index) =>
                                                                        dictionary[
                                                                            entry[0]
                                                                            ] && (
                                                                            <Row
                                                                                key={index}
                                                                            >
                                                                                <Col>
                                                                                    {`${
                                                                                        dictionary[
                                                                                            entry[0]
                                                                                            ]
                                                                                    }: ${
                                                                                        entry[1] ||
                                                                                        '-'
                                                                                    }`}
                                                                                </Col>
                                                                            </Row>
                                                                        )
                                                                )}
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </li>
                                        )}
                                        {selectedEmergency.battery >= 20 && (
                                            <li>
                                                <input checked={stepsChecked.includes('call')} type="checkbox" name="call" onChange={onChange} />
                                                <label htmlFor="call">
                                                    Передзвоніть потерпілому!
                                                </label>
                                            </li>
                                        )}

                                        {selectedEmergency.battery < 20 && (
                                            <li>
                                                <input checked={stepsChecked.includes('sms')} type="checkbox" name="sms" onChange={onChange} />
                                                <label htmlFor="sms">
                                                    {
                                                        'Уточнити наявність джерела живлення!'
                                                    }
                                                </label>
                                            </li>
                                        )}
                                        <li>
                                            <input checked={stepsChecked.includes('additional')} type="checkbox" name="additional" onChange={onChange} />
                                            <label htmlFor="additional">
                                                Додаткова інформація (документуйте в
                                                "Нотатки"):
                                            </label>
                                            <p>
                                                - уточнити місцезнаходження згідно отриманих
                                                координат;
                                                <br />
                                                - уточнити можливість самостійно
                                                пересуватися;
                                                <br />
                                                - уточнити одяг людини та наявність особливих прикмет;
                                                <br />
                                                - уточнити наявність травм та їх важкість;
                                                <br />
                                                - уточнити заряд телефону і наявність
                                                додаткового джерела живлення (Powerbank)
                                                <br />
                                            </p>
                                        </li>
                                        <li>
                                            <input checked={stepsChecked.includes('DSNS')} type="checkbox" name="DSNS" onChange={onChange} />
                                            <label htmlFor="DSNS">
                                                Передайте інформацію у відповідний підрозділ ДСНС!
                                            </label>
                                        </li>
                                    </ol>

                                    <h6 className="mt-2">Нотатки</h6>
                                    <textarea
                                        className="w-100 mt-1 mb-2"
                                        style={{ resize: 'vertical' }}
                                        onChange={e => setNotes(e.target?.value)}
                                    />
                                </Col>
                                <Col lg={5} className="pb-3">
                                    <MapComponent
                                        styles={{
                                            width: '100%',
                                            height: '100%',
                                            maxHeight: '370px',
                                            minHeight: '370px'
                                        }}
                                        location={selectedEmergency}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            Загальні положення
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            - забезпечити прийняття від заявника
                                            інформації про подію протягом двох хвилин,
                                            та внести її до системи; <br />
                                            - під час спілкування із заявником
                                            дотримуватися принципів професійної етики та
                                            моралі; <br />
                                            - якщо в повідомленні йдеться про питання,
                                            що не належать до компетенції ІС
                                            "Порятунок", по можливості коротко допомогти
                                            людині порадою та завершити дзвінок; <br />
                                            - якщо заявник застосовує ненормативну
                                            лексику чи вдається до образ, оператор
                                            роз'яснює, що за такі дії заявник може нести
                                            передбачену законом відповідальність.
                                            Оператор повинен попередити про блокування
                                            вказаного номеру за допомогою технічних
                                            засобів та має право припинити спілкування з
                                            даним заявником. При повторному зверненні
                                            заявника з використанням образ ЗАБЛОКУВАТИ
                                            подальше прийняття від нього звернень.{' '}
                                            <br />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Row>
                        </Container>
                        <div className="pt-2 d-flex align-items-center justify-content-center">
                            <Button
                                variant="success"
                                className="finish px-2"
                                disabled={!(falseAlarm || stepsChecked.length === listRef?.current?.children?.length)}
                                onClick={() => processFinish()}
                            >
                                Завершити роботу над подією
                            </Button>
                        </div>
                    </Modal.Body>
                </>
            )}
            </Modal>
    );
}

export default StepsModal;
